import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ISchemaRequest } from '../../../models/index';
import { GetSchemaState } from '../../actions/types/events/FetchSchemaDetailTypes';

/**
 * Initial Schema state in store
 */
const initialState: GetSchemaState = {
  isLoading: false,
  schemaErrorMessage: '',
  errorCode: '',
  schemaDetails: {
    subject: '',
    version: '',
    id: 0,
    schema: ''
  }
};

const getSchemaNameSlice = createSlice({
  name: 'fetchSchemaName',
  initialState,
  reducers: {
    fetchSchemaNameStarted: (state) => {
      state.isLoading = true;
    },

    fetchSchemaNameSuccess: (state, action: PayloadAction<ISchemaRequest>) => {
      state.isLoading = false;
      state.schemaDetails = action.payload;
      state.schemaErrorMessage = '';
    },

    fetchSchemaNameFail: (state, action: PayloadAction<{ schemaErrorMessage: string, errorCode: string }>) => {
      state.isLoading = false;
      state.schemaDetails = initialState.schemaDetails;
      state.schemaErrorMessage = action.payload.schemaErrorMessage;
      state.errorCode = action.payload.errorCode;
    },

    clearSchemaDetails: (state) => {
      state.isLoading = false;
      state.schemaDetails = initialState.schemaDetails;
      state.schemaErrorMessage = '';
      state.errorCode = '';
    }
  }
});
export const {
  fetchSchemaNameStarted,
  fetchSchemaNameSuccess,
  fetchSchemaNameFail,
  clearSchemaDetails
} = getSchemaNameSlice.actions;
export default getSchemaNameSlice.reducer;
